import { deprecated_353C43, deprecated_FFB200 } from '../../styles/deprecated-colors';

export const Yoga = ({
    lineColor = deprecated_353C43,
    color = deprecated_FFB200,
    strokeWidth = '2.7',
}: {
    lineColor?: string;
    color?: string;
    strokeWidth?: string;
}): JSX.Element => (
    <svg viewBox="0 0 81 94" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-151.000000, -183.000000)">
                <g transform="translate(152.000000, 184.000000)">
                    <path
                        d="M28.5165283,35.38025 C28.5165283,35.38025 28.7006792,35.58125 29.0448302,35.90675"
                        stroke={color}
                        strokeWidth={strokeWidth}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M34.8896604,39.78875 C38.3885283,41.28275 42.9470189,41.81075 47.5643774,38.34425"
                        stroke={color}
                        strokeWidth={strokeWidth}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeDasharray="1.403999984264374,7.023000240325928"
                    />
                    <path
                        d="M50.1690566,35.94575 C50.3350943,35.76275 50.5011321,35.57525 50.6656604,35.38025"
                        stroke={color}
                        strokeWidth={strokeWidth}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M29.5123019,69.3398 L49.3055094,69.3398"
                        stroke={color}
                        strokeWidth={strokeWidth}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeDasharray="1.5,7.5"
                    />
                    <path
                        d="M65.5551698,27.5522 C72.5861132,27.5522 78.2857358,33.2162 78.2857358,40.2032 C78.2857358,47.1902 72.5861132,52.8542 65.5551698,52.8542 C58.5242264,52.8542 52.8246038,47.1902 52.8246038,40.2032 C52.8246038,33.2162 58.5242264,27.5522 65.5551698,27.5522"
                        fill={color}
                        fillRule="nonzero"
                    />
                    <path
                        d="M22.0137358,74.8754 C23.1714717,74.6534 25.5126038,73.7054 25.8929811,73.1234 C27.0371321,71.3654 28.2009057,64.0214 27.2650566,58.3334 C26.3276981,52.6469 25.496,49.6469 25.0793962,52.9559 C24.6627925,56.2649 23.2861887,63.7904 22.685434,65.1569 C20.7669434,69.5279 13.7375094,74.8784 12.0726038,75.6014"
                        stroke={lineColor}
                        strokeWidth={strokeWidth}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M10.9752453,80.25575 C18.306566,74.77625 42.9782642,81.59975 47.5548679,76.11875 C49.9367547,73.27025 50.7443019,72.80975 52.7216604,73.94825 C54.6990189,75.08525 54.5284528,75.70625 57.4416604,74.15525 C60.3548679,72.60275 62.6431698,76.53425 63.3737358,77.77475 C65.3767547,78.01625 66.1375094,79.12025 65.0763774,80.50175 C64.3563774,81.43775 61.6046792,79.63475 59.9382642,79.42775 C57.9110943,79.17575 28.6175094,89.04425 17.690717,90.90725 C6.76543396,92.76875 -0.310792453,85.63325 0.418264151,82.01375 C1.14581132,78.39425 4.68392453,75.80825 12.0726038,75.60125 C13.6001509,75.55925 15.0220377,75.53825 16.3246792,75.51725"
                        stroke={lineColor}
                        strokeWidth={strokeWidth}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M44.2403019,25.1777 C43.986717,27.9377 44.8033208,32.1197 45.9701132,32.4497 C48.2750189,33.1007 56.2840755,34.3097 57.5338868,37.4117 C58.7821887,40.5137 60.1482264,55.6097 61.4704906,59.4512 C63.2757736,64.6967 68.2961509,70.7852 69.3633208,71.3957 C72.8606792,73.3937 78.0818113,75.4307 77.8433208,78.3617 C77.6048302,81.2912 76.7157736,79.5317 76.7157736,79.5317"
                        stroke={lineColor}
                        strokeWidth={strokeWidth}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M53.1304151,52.95545 C53.5455094,56.26445 54.9221132,63.79145 55.5228679,65.15795 C57.4413585,69.52745 64.4723019,74.87795 66.1372075,75.60245"
                        stroke={lineColor}
                        strokeWidth={strokeWidth}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M14.3833962,78.7514 C15.1109434,77.5109 17.8626415,72.6029 20.7758491,74.1554 C23.690566,75.7064 23.4807547,76.5329 25.4581132,75.3959 C27.4354717,74.2589 28.2822642,73.2704 30.6611321,76.1189 C31.4913208,77.1134 33.0067925,78.0359 34.9358491,78.3674"
                        stroke={lineColor}
                        strokeWidth={strokeWidth}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M61.8066415,75.5156 C63.133434,75.5381 64.584,75.5576 66.1447547,75.6026 C73.533434,75.8081 77.0715472,78.3941 77.8006038,82.0136 C78.5281509,85.6331 71.453434,92.7686 60.5251321,90.9071 C55.6753208,90.0806 47.2058868,87.6761 39.109283,85.2806"
                        stroke={lineColor}
                        strokeWidth={strokeWidth}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M53.1378113,52.95545 C52.722717,49.64645 51.8895094,52.64645 50.9536604,58.33295 C50.0163019,64.02095 51.5770566,72.18995 52.722717,73.94795"
                        stroke={lineColor}
                        strokeWidth={strokeWidth}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M47.2975094,13.23545 C48.2333585,21.90095 44.0280755,27.24845 39.1088302,27.24845 C34.1895849,27.24845 30.450717,20.11145 31.0605283,12.62645 C31.0605283,12.62645 37.3775094,12.32195 41.5178868,9.39545 L47.2975094,13.23545 Z"
                        stroke={lineColor}
                        strokeWidth={strokeWidth}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M1.4949434,79.53215 C1.4949434,79.53215 0.605886792,81.29165 0.365886792,78.36215 C0.127396226,75.43115 5.3485283,73.39265 8.84739623,71.39465 C9.91456604,70.78565 14.933434,64.69565 16.738717,59.45015 C18.0609811,55.61015 19.4270189,40.51415 20.6768302,37.41065 C21.9251321,34.31015 29.7424906,33.25565 32.2390943,32.45015 C35.573434,31.37465 35.3696604,25.75715 34.9349434,25.76315 C27.3062642,25.87115 25.664,24.57065 25.664,24.57065 C25.664,24.57065 26.1349434,18.84215 27.1689057,11.58965 C28.4202264,2.79965 35.1311698,0.85715 35.1311698,0.85715 C38.8202264,0.18065 38.8202264,0.18065 43.0209811,0.85715 C43.0209811,0.85715 48.8624906,2.96615 50.9832453,11.58965 C52.6375849,18.32165 53.1296604,24.08315 53.1296604,24.08315 C53.1296604,24.08315 49.8632453,26.46815 44.2028679,25.76315"
                        stroke={lineColor}
                        strokeWidth={strokeWidth}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M34.7784151,16.37975 C34.7784151,16.37975 35.7278491,17.39225 36.7693585,16.37975"
                        stroke={lineColor}
                        strokeWidth={strokeWidth}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M41.3592453,16.37975 C41.3592453,16.37975 42.3086792,17.39225 43.3501887,16.37975"
                        stroke={lineColor}
                        strokeWidth={strokeWidth}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
            </g>
        </g>
    </svg>
);
